function getTokenData(token?: string) {
  if (!token) {
    return { tokenExpired: true };
  }
  const payloadEncoded = token.split('.')[1];

  if (!payloadEncoded) {
    return { tokenExpired: true };
  }

  const payloadDecoded = atob(payloadEncoded);

  const payload = JSON.parse(payloadDecoded);

  if (!payload.exp) {
    return { tokenExpired: true };
  }

  const currentDate = Math.floor(Date.now() / 1000);

  return { tokenExpired: currentDate > payload.exp, userIdFromToken: payload.userId };
}

export default getTokenData;
